import { useCallback, useEffect, useRef } from 'react';
import { useNotificaciones } from '../../../globales/contextos/notificationContext';
import { EnumTipoNotificacion } from '../../../globales/interfaces';

/** Mensaje para el usuario: el del back si lo trae; sin respuesta del servidor, uno de conexión. */
export const mensajeErrorConsulta = (error: any, que: string) =>
    error?.mensajeBackend
    || (error?.response
        ? `No se pudo consultar ${que}. Intenta nuevamente.`
        : `No se pudo consultar ${que}. Verifica tu conexión e intenta nuevamente.`);

/**
 * Avisa con una notificación cuando falla una consulta (antes solo quedaba en la consola y la pantalla se veía
 * vacía sin explicación). La función devuelta es estable: se puede usar dentro de efectos de carga sin que se
 * vuelvan a ejecutar (mostrarNotificacion cambia en cada render).
 */
export const useAvisoErrorConsulta = () => {
    const { mostrarNotificacion } = useNotificaciones();
    const notificar = useRef(mostrarNotificacion);
    useEffect(() => { notificar.current = mostrarNotificacion; }, [mostrarNotificacion]);

    /** siNoExiste: aviso (no error) cuando el back responde 404, p. ej. un país que aún no tiene configuración. */
    return useCallback((error: unknown, que: string, siNoExiste?: string) => {
        console.error(`Error al consultar ${que}:`, error);
        if (siNoExiste && (error as any)?.response?.status === 404) {
            notificar.current(EnumTipoNotificacion.Warning, 'Sin datos', siNoExiste);
            return;
        }
        notificar.current(EnumTipoNotificacion.Error, 'Error al consultar', mensajeErrorConsulta(error, que));
    }, []);
};
